import { useMemo } from "react";

import { ClientGateway } from "@kex/api";

import { useSessionsList } from "./use-sessions-list";

type UseSessionDetailsParams = {
  id: string;
};

export const useSessionDetails = ({ id }: UseSessionDetailsParams) => {
  const { refetch, sessions, isPending } = useSessionsList();

  const session = useMemo<ClientGateway.SessionModel | undefined>(
    () => sessions.find((item) => item.id === id),
    [sessions, id],
  );

  return { refetch, session, isPending };
};
